import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../utils/axios";

const initialState = {
  loading: false,
  mallsData: [],
  error: "",
  success: false,
  status: "",
};

const fetchMalls = createAsyncThunk("fetch/malls", async () => {
  try {
    const result = await axios.get(`${process.env.REACT_APP_CMS_URL}/malls?populate=*`, {
      commonHeaderNotRequired: true,
    });
    return result?.data;
  } catch (err) {
    console.log(err);
  }
});

const mallsSlice = createSlice({
  name: "malls",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchMalls.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchMalls.fulfilled, (state, action) => {
      state.loading = false;
      state.mallsData = action?.payload?.data;
      //   state.success = action?.payload;
      state.error = "";
    });
    builder.addCase(fetchMalls.rejected, (state, action) => {
      state.loading = false;
      state.mallsData = [];
      state.error = action.error.message;
    });
  },
});

export default mallsSlice.reducer;
export { fetchMalls };
